import { nextTick } from 'vue';
import store from '@/store';
import util from '@/libs/util';
export default {
  install: function install(app, options) {
    app.config.errorHandler = function (error, instance, info) {
      nextTick(function () {
        // store 追加 log
        store.dispatch('admin/log/push', {
          message: "".concat(info, ": ").concat(error.message),
          type: 'error',
          meta: {
            error: error
            // instance
          }
        });
        // 只在开发模式下打印 log
        if (process.env.NODE_ENV === 'development') {
          util.log.capsule('中国崇福', 'ErrorHandler', 'error');
          util.log.error('>>>>>> 错误信息 >>>>>>');
          console.log(info);
          util.log.error('>>>>>> Vue 实例 >>>>>>');
          console.log(instance);
          util.log.error('>>>>>> Error >>>>>>');
          console.log(error);
        }
      });
    };
  }
};